import { Duration } from "luxon";
import z from "zod/v4";

export const isoDurationToMillis = z.codec(z.iso.duration(), z.number(), {
  decode: (isoDuration) => Duration.fromISO(isoDuration).as("milliseconds"),
  encode: (millis) => Duration.fromMillis(millis).toISO(),
});
